import { assert_type_boolean } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';

export class DTODiffusionModelUDBase extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */

  static SORT_KEYS: string[] = ['name', 'version', 'base_model', 'type', 'rent_price'];

  /*
   * DB FIELDS
   */

  /*
   * RUNTIME FIELDS
   */

  is_ready_to_use!: boolean;

  /*
   * METHODS
   */

  assert_standard_fields() {
    super.assert_standard_fields();

    assert_type_boolean(this.is_ready_to_use);
  }
}
